// extracted by mini-css-extract-plugin
export default {"SignIn":"SignIn_SignIn__GEDS9","bg-image":"SignIn_bg-image__Hg0xY","layer":"SignIn_layer__Ew4ej"};